import React, { FC, useEffect } from 'react'
import clsx from 'clsx'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Drawer from '@material-ui/core/Drawer'
import { Theme } from '@material-ui/core'
import navigationConfig from '../../../config/navigationConfig'
import NavigationList from '../NavigationList/NavigationList'
import { hasAccess } from '../../../helpers/functions/hasAccess'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: '100%',
        overflowY: 'auto',
    },
    content: {
        padding: theme.spacing(2),
    },
    profile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'fit-content',
    },
    avatar: {
        width: 60,
        height: 60,
    },
    name: {
        marginTop: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(2),
    },
}))

interface Props {
    open: boolean
    className: string
    onClose?: () => void
}

const NavBar: FC<Props> = ({ open = false, onClose, className = '', ...rest }) => {
    const classes = useStyles()

    useEffect(() => {
        if (!open) {
            onClose()
        }
    }, [onClose, open])

    return (
        <Drawer anchor="left" onClose={onClose} open={open}>
            <div {...rest} className={clsx(classes.root, className)}>
                <div className={classes.content}>
                    {navigationConfig &&
                        navigationConfig
                            .filter((nav) => hasAccess(nav))
                            .map((page) => <NavigationList key={page.title} onClose={onClose} page={page} />)}
                </div>
            </div>
        </Drawer>
    )
}

export default NavBar
